import React from "react"
import PropTypes from "prop-types"

import { ZONE_COLORS } from "../static"
import { etiquetaRegion } from "../useAvailabilityCreate"

const PricesPanel = ({
  regions,
  prices,
  hasLocal,
  localName,
  onChange,
  onOpenZones,
}) => {
  const clase = `av-price-grid ${hasLocal ? "has-local" : "no-local"}`

  return (
    <div className="av-panel">
      <div className="av-panel-title">Precios por Zona</div>

      <div className={clase}>
        <div className="av-price-head">Zona</div>
        <div className="av-price-head">P. Destino</div>
        {hasLocal && <div className="av-price-head">P. Granja {localName}</div>}
      </div>

      {regions.length === 0 && (
        <div className="av-view-obs">Esta sucursal no tiene zonas.</div>
      )}

      {regions.map((region, index) => {
        const precio = prices[region.id] || {}
        return (
          <div className={clase} key={region.id}>
            <div className="av-zone" title={etiquetaRegion(region, regions)}>
              <span
                className="av-dot"
                style={{
                  background: ZONE_COLORS[index % ZONE_COLORS.length],
                }}
              />
              {etiquetaRegion(region, regions)}
            </div>
            <input
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              className="av-price-input av-num"
              value={precio.destino || ""}
              onChange={event =>
                onChange(region.id, "destino", event.target.value)
              }
            />
            {hasLocal && (
              <input
                type="number"
                min="0"
                step="0.01"
                placeholder="0.00"
                className="av-price-input av-num"
                value={precio.granja || ""}
                onChange={event =>
                  onChange(region.id, "granja", event.target.value)
                }
              />
            )}
          </div>
        )
      })}

      {onOpenZones && (
        <div className="av-zones-foot">
          <span className="av-zones-summary">{resumenSubzonas(regions)}</span>
          <button type="button" className="av-btn-zones" onClick={onOpenZones}>
            <i className="bx bx-package" />
            Sub-zonas
          </button>
        </div>
      )}
    </div>
  )
}

/** "Sub-zonas — Puebla: 2 · Cdmx: 1", o el aviso de que no hay ninguna. */
function resumenSubzonas(regions) {
  const conteos = (regions || [])
    .filter(region => !region.parent_id)
    .map(padre => ({
      nombre: padre.name,
      total: (regions || []).filter(region => region.parent_id === padre.id)
        .length,
    }))
    .filter(item => item.total > 0)
    .map(item => `${item.nombre}: ${item.total}`)

  return conteos.length
    ? `Sub-zonas — ${conteos.join(" · ")}`
    : "Sin sub-zonas definidas"
}

PricesPanel.propTypes = {
  regions: PropTypes.array.isRequired,
  prices: PropTypes.object.isRequired,
  hasLocal: PropTypes.bool,
  localName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onOpenZones: PropTypes.func,
}

export default PricesPanel
